import React, { createContext, useContext, useEffect, useState } from 'react';

const ViewModeContext = createContext();

// Valid "Ghost Keys" for client access - these are secure, long-form keys
// that cannot be easily reverse-engineered
const VALID_GHOST_KEYS = [
  'pragma-v1-8829-x92-elite-client-access',
  'pragma-elite-2025-client-secret-key',
  'pragma-secret-access-key-verified-client'
];

export const ViewModeProvider = ({ children }) => {
  const [viewMode, setViewMode] = useState('agent'); // default to 'agent'

  useEffect(() => {
    // Extract the URL parameter on mount
    const params = new URLSearchParams(window.location.search);
    const auth = params.get('auth');

    // Check if the provided key is valid
    if (auth && VALID_GHOST_KEYS.includes(auth)) {
      setViewMode('client');
      // Store in localStorage for persistence across sessions
      localStorage.setItem('pragma_view_mode', 'client');
    } else {
      // Check localStorage for previous client access
      const storedMode = localStorage.getItem('pragma_view_mode');
      if (storedMode === 'client') {
        setViewMode('client');
      } else {
        setViewMode('agent');
      }
    }

    // Always hide the parameter from the URL bar
    window.history.replaceState({}, document.title, window.location.pathname);
  }, []);

  return (
    <ViewModeContext.Provider value={{ viewMode, setViewMode }}>
      {children}
    </ViewModeContext.Provider>
  );
};

export const useViewMode = () => {
  const context = useContext(ViewModeContext);
  if (!context) {
    throw new Error('useViewMode must be used within ViewModeProvider');
  }
  return context;
};
